import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ContentService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';

@Component({
  selector: 'lcp-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent {
  // jobListing: TypeJobListingFields | null = null;
  route$: any
  filter$: any
  // filterLookup: any
  project: any
  projectFeaturedMedia: any[]
  projectTags: any[]
  
  constructor(
    public contentService: ContentService,
    public lcpHelper: LcpHelper, 
    public route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route$ = this.routeStream()
    // this.getFilters()
    this.filter$ = this.filtersStream()
  }

  routeStream() {
    return this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.contentService.getProjectsBySlug(params.get('slug') as string)
      )).subscribe({
       next: (projects) => {
        this.project = projects.items[0]
        this.projectFeaturedMedia = this.project.fields['media'] && this.project.fields['media'][0]
        // console.log('featuredMedia', this.projectFeaturedMedia, this.project.fields)
        this.projectTags = this.project.metadata.tags
        // console.log('fields:', this.project.fields, this.projectFeaturedMedia[0].fields.content_type)
      }})
  }

  filtersStream() {
    return this.contentService.getFilters().subscribe(filters => {
      // let filterLookupTemp:any = {}
      filters.items.map(x => { 
        if (x.fields['type'] !== 'tag' || !x.fields['name']) return
        let name: any = x.fields['name']
        delete x.fields['name']
        // filterLookupTemp[name]= x.fields
      })
      // this.filterLookup = filterLookupTemp
      // console.log('filterLookup', this.filterLookup, pt, this.filterLookup[pt])
    })
  }
  
}
